<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 21"
    fill="none"
    :width="width"
    :height="height"
  >
    <circle cx="10" cy="10.5" r="10" :fill="color" />
    <path
      d="M9.13885 13.3023L14 8.28906"
      :stroke="strokeColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="bevel"
    />
    <path
      d="M9.09709 13.3023L6.66666 10.7959"
      :stroke="strokeColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="bevel"
    />
  </svg>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'CgIconCheckCircle',
  props: {
    width: {
      type: [Number, String],
      required: false,
      default: 20,
    },
    height: {
      type: [Number, String],
      required: false,
      default: 20,
    },
    color: {
      type: String,
      required: false,
      default: '#42B77A',
    },
    strokeColor: {
      type: String,
      required: false,
      default: '#fff',
    },
  },
});
</script>
